import { channelsInstance } from '@/api/instances'
import { CHANNEL_SUBCATEGORIES, ChannelStatus } from '@/models/channels'
import { ORDER_QUEUE_BY } from '@/models/virtualClinic'
import { UserRole } from '@/modules/user/constants/user.constant' //TODO: Add import to index when pass to service
import DatabaseFactory from '@/wrappers/database'
import { addErrorLog } from '@/wrappers/database/utils/addLog'
import Logger, {
  EventModel,
  EventName,
  LogLevel,
  ProviderType
} from '@/wrappers/logger'

import { mapDocs } from '../channel/drawer/utils'

const fetchVirtualClinicChannels = (store, callback) => {
  try {
    const staffId = store.rootState.user.user.id

    if (!staffId) return

    const database = new DatabaseFactory(
      `staff/${staffId}/channels`
    ).getReadDatabase()

    const query = {
      filters: [
        {
          field: 'subCategory',
          condition: '==',
          value: CHANNEL_SUBCATEGORIES.VIRTUAL_CLINIC
        },
        {
          field: 'status',
          condition: '==',
          value: ChannelStatus.ACTIVE
        }
      ],
      limit: 1
    }

    const listener = database.getStream(
      query,
      snapshot => {
        const { docs } = snapshot
        const channels = mapDocs(docs)
        callback(channels)
        store.dispatch('addLog', {
          value: { channels },
          context: 'fetchVirtualClinicChannels'
        })

        store.dispatch(
          'channel/drawer/fetchMembersInfo',
          {
            docs,
            leanResponse: true
          },
          { root: true }
        )
      },
      error =>
        addErrorLog({
          context: 'fetchVirtualClinicChannels',
          error
        })
    )

    return listener
  } catch (error) {
    throw new Error(`Error on drawer/fetchVirtualClinicChannels: ${error}`)
  }
}

const getNextChannel = async store => {
  try {
    const response = await channelsInstance.post('channels/next_virtual_clinic')
    store.dispatch('addLog', {
      value: { channelId: response?.id },
      context: 'getNextChannel'
    })
    return true
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'channel/getNextChannel',
        message: 'Não foi possível pegar o próximo atendimento'
      },
      { root: true }
    )
    return false
  }
}

const fetchQueueInformation = (store, { orderBy }) => {
  store.commit('clearQueueListener')

  const database = new DatabaseFactory('virtual_clinic_queue').getReadDatabase()

  const query = {
    orderBy: []
  }

  if (orderBy === ORDER_QUEUE_BY.PEDIATRIC) {
    query.orderBy.push({ field: 'segment', sort: 'desc' })
  }

  query.orderBy.push({ field: 'queuedAt', sort: 'asc' })

  const queueListener = database.getStream(
    query,
    snapshot => {
      const queue = snapshot.docs.map(doc => doc.data())

      store.commit('setQueue', queue)
      store.dispatch('addLog', {
        value: { queue, queueSize: queue.length },
        context: 'fetchQueueInformation'
      })
    },
    error =>
      addErrorLog({
        context: 'fetchQueueInformation',
        error
      })
  )
  store.commit('setQueueListener', queueListener)
}

const getVirtualClinicQueue = (store, loggedStaff) => {
  const isOnCall = loggedStaff.isOnCall
  const isPediatric =
    loggedStaff.role === UserRole.VIRTUAL_CLINIC_PEDIATRIC_PHYSICIAN
  const hasVirtualClinicRole =
    loggedStaff.role === UserRole.VIRTUAL_CLINIC_PHYSICIAN || isPediatric

  const showPediatricFirst = isPediatric && !isOnCall

  if (!hasVirtualClinicRole && !isOnCall) {
    store.dispatch('clearState')
    return
  }

  store.dispatch('fetchQueueInformation', {
    orderBy: showPediatricFirst
      ? ORDER_QUEUE_BY.PEDIATRIC
      : ORDER_QUEUE_BY.FIRST
  })
}

const getQueueHistory = async (store, pagination) => {
  const userId = store.rootState.user.user.id
  const database = new DatabaseFactory(
    `staff/${userId}/channels`
  ).getReadDatabase()

  const previous = new Date(new Date().setDate(new Date().getDate() - 1))

  const query = {
    filters: [
      {
        field: 'subCategory',
        condition: '==',
        value: CHANNEL_SUBCATEGORIES.VIRTUAL_CLINIC
      },
      {
        field: 'status',
        condition: '==',
        value: ChannelStatus.ARCHIVED
      },
      {
        field: 'timeLastMessage',
        condition: '>=',
        value: previous
      }
    ],
    orderBy: [{ field: 'timeLastMessage', sort: 'desc' }],
    limit: pagination.limit,
    startAfter: pagination.startAfter,
    endBefore: pagination.endBefore
  }

  try {
    const snapshot = await database.get(query)

    store.dispatch(
      'channel/drawer/fetchMembersInfo',
      {
        docs: snapshot.docs,
        leanResponse: true
      },
      { root: true }
    )

    const history = snapshot.docs.map(doc => ({
      ...doc.data(),
      id: doc.id
    }))
    return {
      history,
      lastVisibleDocument: snapshot.docs[snapshot.docs.length - 1],
      firstVisibleDocument: snapshot.docs[0]
    }
  } catch (error) {
    addErrorLog({
      context: 'getQueueHistory',
      error
    })
    return []
  }
}

const addLog = (_, data) => {
  Logger.addLog(
    EventName.USER_INTERACTION,
    {
      model: EventModel.VIRTUAL_CLINIC,
      data: {
        ...data
      }
    },
    {
      isAction: false,
      logLevel: LogLevel.INFO
    },
    [ProviderType.DATADOG]
  )
}

const clearState = store => {
  store.commit('clearQueueListener')
  store.commit('setQueue', null)
}
export default {
  getNextChannel,
  fetchQueueInformation,
  fetchVirtualClinicChannels,
  clearState,
  getVirtualClinicQueue,
  getQueueHistory,
  addLog
}
